import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { blockquoteVariants } from "./Blockquote.variants.js";
const Blockquote_Blockquote = /*#__PURE__*/ forwardRef(function({ children, attribution, attributionComponent, className, container = 'lg', ...props }, ref) {
    const { root, borderSlot, contentSlot, quoteSlot, attributionSlot, attributionDashSlot, attributionTextSlot } = blockquoteVariants({
        container
    });
    const classes = cn(root(), className);
    const domProps = cleanProps(props, Object.keys(blockquoteVariants.variants));
    let attributionContent = null;
    if (attributionComponent) attributionContent = attributionComponent;
    else if (attribution) attributionContent = /*#__PURE__*/ jsxs("div", {
        className: attributionSlot(),
        children: [
            /*#__PURE__*/ jsx("p", {
                className: attributionDashSlot(),
                children: "–"
            }),
            /*#__PURE__*/ jsx("p", {
                className: attributionTextSlot(),
                children: attribution
            })
        ]
    });
    return /*#__PURE__*/ jsxs("blockquote", {
        ref: ref,
        className: classes,
        ...domProps,
        children: [
            /*#__PURE__*/ jsx("div", {
                className: borderSlot()
            }),
            /*#__PURE__*/ jsxs("div", {
                className: contentSlot(),
                children: [
                    /*#__PURE__*/ jsx("p", {
                        className: quoteSlot(),
                        children: children
                    }),
                    attributionContent
                ]
            })
        ]
    });
});
export { Blockquote_Blockquote as Blockquote };
